[
  {
    "id": "x",
    "name": "X",
    "methods": [
      "browser"
    ],
    "entry_url": "https://x.com/compose/post",
    "dynamic_host": false,
    "hosts": [
      "x.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 280,
          "transfer": "text",
          "selectors": [
            "[role=\"dialog\"] [data-testid=\"tweetTextarea_0\"][contenteditable=\"true\"]"
          ],
          "format": "plain",
          "length_metric": "twitter"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "max_count": 4,
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "unattended": {
      "account": "a[data-testid='AppTabBar_Profile_Link']",
      "submit": "[role='dialog'] [data-testid='tweetButton']",
      "result": "[data-testid='toast'] a[href*='/status/']"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "x.com",
      "twitter.com"
    ]
  },
  {
    "id": "linkedin",
    "name": "LinkedIn",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.linkedin.com/sharing/compose",
    "dynamic_host": false,
    "hosts": [
      "linkedin.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 3000,
          "transfer": "text",
          "selectors": [
            "[componentkey=\"ShareBox_textEditor\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "linkedin-page",
    "name": "LinkedIn Page",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.linkedin.com/company/",
    "dynamic_host": false,
    "hosts": [
      "linkedin.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Page URL",
            "主页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 3000,
          "transfer": "text",
          "selectors": [
            ".ql-editor[contenteditable=\"true\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "reddit",
    "name": "Reddit",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "reddit",
    "credential_kind": "oauth",
    "entry_url": "https://www.reddit.com/submit",
    "dynamic_host": false,
    "hosts": [
      "reddit.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "community",
          "label": [
            "Community",
            "社区"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 300,
          "transfer": "text",
          "selectors": [
            "textarea[name=\"title\"]",
            "input[name=\"title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Text",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 10000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "flair",
          "label": [
            "Flair",
            "分类标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "nsfw",
          "label": [
            "Adult content",
            "成人内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "否"
            ],
            "yes": [
              "Yes",
              "是"
            ]
          }
        },
        {
          "key": "spoiler",
          "label": [
            "Spoiler",
            "剧透"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "否"
            ],
            "yes": [
              "Yes",
              "是"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "instagram",
    "name": "Instagram",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.instagram.com/",
    "dynamic_host": false,
    "hosts": [
      "instagram.com"
    ],
    "preview": {
      "layout": "gallery",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 2200,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]",
            "[contenteditable=\"true\"][aria-label=\"Add a caption...\"]"
          ],
          "format": "plain"
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collaborators",
          "label": [
            "Collaborators",
            "协作者"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "ai_label",
          "label": [
            "AI label",
            "AI 标注"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "off",
            "on"
          ],
          "option_labels": {
            "off": [
              "No AI label",
              "不标注"
            ],
            "on": [
              "Made with AI",
              "标注为 AI 生成"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "max_count": 10
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "instagram-standalone",
    "name": "Instagram (Instagram Login)",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.instagram.com/",
    "dynamic_host": false,
    "hosts": [
      "instagram.com"
    ],
    "preview": {
      "layout": "gallery",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 2200,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]",
            "[contenteditable=\"true\"][aria-label=\"Add a caption...\"]"
          ],
          "format": "plain"
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collaborators",
          "label": [
            "Collaborators",
            "协作者"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "ai_label",
          "label": [
            "AI label",
            "AI 标注"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "off",
            "on"
          ],
          "option_labels": {
            "off": [
              "No AI label",
              "不标注"
            ],
            "on": [
              "Made with AI",
              "标注为 AI 生成"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "max_count": 10
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "facebook",
    "name": "Facebook",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.facebook.com/",
    "dynamic_host": false,
    "hosts": [
      "facebook.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Page or profile URL",
            "主页或个人页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 63206,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"][data-lexical-editor=\"true\"]"
          ],
          "format": "plain"
        },
        {
          "key": "audience",
          "label": [
            "Audience",
            "受众"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "threads",
    "name": "Threads",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.threads.com/",
    "dynamic_host": false,
    "hosts": [
      "threads.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topic",
          "label": [
            "Topic",
            "话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "replies",
          "label": [
            "Who can reply",
            "谁可以回复"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "youtube",
    "name": "YouTube",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "google-youtube",
    "credential_kind": "oauth",
    "entry_url": "https://studio.youtube.com/?d=ud",
    "dynamic_host": false,
    "hosts": [
      "studio.youtube.com"
    ],
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 100,
          "transfer": "text",
          "selectors": [
            "#title-textarea #textbox"
          ],
          "min_length": 2
        },
        {
          "key": "body",
          "label": [
            "Description",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 5000,
          "transfer": "text",
          "selectors": [
            "#description-textarea #textbox"
          ],
          "format": "plain"
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "private",
            "unlisted"
          ],
          "option_labels": {
            "public": [
              "Public",
              "公开"
            ],
            "private": [
              "Private",
              "私密"
            ],
            "unlisted": [
              "Unlisted",
              "不公开列出"
            ]
          }
        },
        {
          "key": "kids",
          "label": [
            "Made for kids",
            "是否面向儿童"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "category",
          "label": [
            "Category",
            "类别"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "unattended": {
      "account": "a[href*='/channel/'],ytcp-entity-card a[href*='/channel/']",
      "submit": "ytcp-button#done-button",
      "result": "ytcp-video-share-dialog a[href*='youtu.be/'],ytcp-video-share-dialog a[href*='youtube.com/watch']"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "youtube.com",
      "youtu.be"
    ]
  },
  {
    "id": "gmb",
    "name": "Google Business Profile",
    "methods": [
      "browser"
    ],
    "entry_url": "https://business.google.com/",
    "dynamic_host": false,
    "hosts": [
      "business.google.com"
    ],
    "preview": {
      "layout": "business",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Business dashboard URL",
            "商家管理页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Update",
            "最新动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 1500,
          "transfer": "guided",
          "selectors": [],
          "format": "plain"
        },
        {
          "key": "cta",
          "label": [
            "Action button",
            "行动按钮"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "NONE",
            "BOOK",
            "ORDER",
            "SHOP",
            "LEARN_MORE",
            "SIGN_UP",
            "GET_OFFER",
            "CALL"
          ],
          "option_labels": {
            "NONE": [
              "None",
              "无"
            ],
            "BOOK": [
              "Book",
              "预订"
            ],
            "ORDER": [
              "Order online",
              "在线订购"
            ],
            "SHOP": [
              "Buy",
              "购买"
            ],
            "LEARN_MORE": [
              "Learn more",
              "了解详情"
            ],
            "SIGN_UP": [
              "Sign up",
              "注册"
            ],
            "GET_OFFER": [
              "Get offer",
              "领取优惠"
            ],
            "CALL": [
              "Call now",
              "立即致电"
            ]
          }
        },
        {
          "key": "link",
          "label": [
            "Button link",
            "按钮链接"
          ],
          "kind": "url",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": false,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "google.com",
      "maps.app.goo.gl"
    ]
  },
  {
    "id": "tiktok",
    "name": "TikTok",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.tiktok.com/tiktokstudio/upload",
    "dynamic_host": false,
    "hosts": [
      "tiktok.com"
    ],
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 4000,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content"
          ],
          "format": "plain"
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "friends",
            "followers",
            "private"
          ],
          "option_labels": {
            "public": [
              "Everyone",
              "所有人"
            ],
            "friends": [
              "Friends",
              "好友"
            ],
            "followers": [
              "Followers",
              "粉丝"
            ],
            "private": [
              "Only you",
              "仅自己"
            ]
          }
        },
        {
          "key": "comments",
          "label": [
            "Allow comments",
            "允许评论"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "ai_generated",
          "label": [
            "AI-generated content",
            "AI 生成内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "commercial",
          "label": [
            "Commercial content",
            "商业内容披露"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "own_brand",
            "branded_content"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "own_brand": [
              "Your brand",
              "自有品牌"
            ],
            "branded_content": [
              "Branded content",
              "品牌合作内容"
            ]
          }
        },
        {
          "key": "reuse",
          "label": [
            "Reuse of content",
            "允许二次创作"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "audience_control",
          "label": [
            "Adults only (18+)",
            "仅限成年人（18+）"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "location",
          "label": [
            "Location",
            "位置"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "tiktok-business",
    "name": "TikTok Business",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.tiktok.com/tiktokstudio/upload",
    "dynamic_host": false,
    "hosts": [
      "tiktok.com"
    ],
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "body",
          "label": [
            "Caption",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 4000,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content"
          ],
          "format": "plain"
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "friends",
            "followers",
            "private"
          ],
          "option_labels": {
            "public": [
              "Everyone",
              "所有人"
            ],
            "friends": [
              "Friends",
              "好友"
            ],
            "followers": [
              "Followers",
              "粉丝"
            ],
            "private": [
              "Only you",
              "仅自己"
            ]
          }
        },
        {
          "key": "comments",
          "label": [
            "Allow comments",
            "允许评论"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "ai_generated",
          "label": [
            "AI-generated content",
            "AI 生成内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "yes",
            "no"
          ],
          "option_labels": {
            "yes": [
              "Yes",
              "是"
            ],
            "no": [
              "No",
              "否"
            ]
          }
        },
        {
          "key": "commercial",
          "label": [
            "Commercial content",
            "商业内容披露"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "own_brand",
            "branded_content"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "own_brand": [
              "Your brand",
              "自有品牌"
            ],
            "branded_content": [
              "Branded content",
              "品牌合作内容"
            ]
          }
        },
        {
          "key": "reuse",
          "label": [
            "Reuse of content",
            "允许二次创作"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "audience_control",
          "label": [
            "Adults only (18+)",
            "仅限成年人（18+）"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On",
              "开启"
            ],
            "off": [
              "Off",
              "关闭"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "location",
          "label": [
            "Location",
            "位置"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "video_alone": true,
        "max_count": 35
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "pinterest",
    "name": "Pinterest",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.pinterest.com/pin-creation-tool/",
    "dynamic_host": false,
    "hosts": [
      "pinterest.com"
    ],
    "preview": {
      "layout": "pin",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": 100,
          "transfer": "text",
          "selectors": [
            "input#storyboard-selector-title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content"
          ],
          "format": "plain"
        },
        {
          "key": "link",
          "label": [
            "Destination link",
            "目标链接"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#WebsiteField"
          ]
        },
        {
          "key": "board",
          "label": [
            "Board",
            "画板"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "标记主题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "#combobox-storyboard-interest-tags"
          ]
        },
        {
          "key": "ai_disclosure",
          "label": [
            "AI disclosure",
            "标记为 AI 修改"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "ai_made"
          ],
          "option_labels": {
            "none": [
              "Not AI-made",
              "非 AI 制作"
            ],
            "ai_made": [
              "Made wholly or partly by AI",
              "完全或部分由 AI 制作"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": true,
        "transfer": "guided",
        "max_count": 5
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "dribbble",
    "name": "Dribbble",
    "methods": [
      "browser"
    ],
    "entry_url": "https://dribbble.com/uploads/new",
    "dynamic_host": false,
    "hosts": [
      "dribbble.com"
    ],
    "preview": {
      "layout": "gallery",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 64,
          "transfer": "text",
          "selectors": [
            "textarea#title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "说明"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 40000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "team",
          "label": [
            "Team",
            "团队"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "discord",
    "name": "Discord",
    "methods": [
      "browser"
    ],
    "entry_url": "https://discord.com/channels/@me",
    "dynamic_host": false,
    "hosts": [
      "discord.com"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Message",
            "消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 1980,
          "transfer": "text",
          "selectors": [
            "[role=\"textbox\"][data-slate-editor=\"true\"]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "slack",
    "name": "Slack",
    "methods": [
      "browser"
    ],
    "entry_url": "https://app.slack.com/",
    "dynamic_host": false,
    "hosts": [
      "app.slack.com"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Message",
            "消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 400000,
          "transfer": "text",
          "selectors": [
            "[data-message-input=\"true\"] [contenteditable=\"true\"]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "slack.com"
    ]
  },
  {
    "id": "kick",
    "name": "Kick",
    "methods": [
      "browser"
    ],
    "entry_url": "https://kick.com/",
    "dynamic_host": false,
    "hosts": [
      "kick.com"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "直播频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Chat message",
            "聊天消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "#message-input"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "twitch",
    "name": "Twitch",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.twitch.tv/",
    "dynamic_host": false,
    "hosts": [
      "twitch.tv"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Channel URL",
            "直播频道网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Chat message",
            "聊天消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "[data-a-target=\"chat-input\"]"
          ],
          "format": "plain"
        },
        {
          "key": "messageType",
          "label": [
            "Message type",
            "消息类型"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "message",
            "announcement"
          ],
          "option_labels": {
            "message": [
              "Chat message",
              "聊天消息"
            ],
            "announcement": [
              "Announcement",
              "公告"
            ]
          }
        },
        {
          "key": "announcementColor",
          "label": [
            "Announcement colour",
            "公告颜色"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "required_when": {
            "field": "messageType",
            "value": "announcement"
          },
          "options": [
            "primary",
            "blue",
            "green",
            "orange",
            "purple"
          ],
          "option_labels": {
            "primary": [
              "Channel accent",
              "频道主色"
            ],
            "blue": [
              "Blue",
              "蓝色"
            ],
            "green": [
              "Green",
              "绿色"
            ],
            "orange": [
              "Orange",
              "橙色"
            ],
            "purple": [
              "Purple",
              "紫色"
            ]
          }
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "mastodon",
    "name": "Mastodon",
    "methods": [
      "browser",
      "api"
    ],
    "credential_provider": "mastodon",
    "credential_kind": "service_account",
    "entry_url": "https://mastodon.social/publish",
    "dynamic_host": true,
    "hosts": [
      "mastodon.social"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Instance composer URL",
            "实例编辑页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 500,
          "transfer": "text",
          "selectors": [
            "textarea.autosuggest-textarea__textarea"
          ],
          "format": "plain"
        },
        {
          "key": "warning",
          "label": [
            "Content warning",
            "内容警告"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input.spoiler-input__input"
          ]
        },
        {
          "key": "visibility",
          "label": [
            "Visibility",
            "可见性"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "public",
            "private",
            "unlisted"
          ],
          "option_labels": {
            "public": [
              "Public",
              "公开"
            ],
            "private": [
              "Followers only",
              "仅关注者"
            ],
            "unlisted": [
              "Unlisted",
              "不公开列出"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "bluesky",
    "name": "Bluesky",
    "methods": [
      "browser",
      "api"
    ],
    "credential_provider": "bluesky",
    "credential_kind": "service_account",
    "entry_url": "https://bsky.app/intent/compose",
    "dynamic_host": false,
    "hosts": [
      "bsky.app"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 300,
          "transfer": "text",
          "selectors": [
            ".tiptap.ProseMirror"
          ],
          "format": "plain"
        },
        {
          "key": "alt",
          "label": [
            "Alternative text",
            "图片替代文本"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "language",
          "label": [
            "Language",
            "语言"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "max_count": 4,
        "video_alone": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "lemmy",
    "name": "Lemmy",
    "methods": [
      "browser",
      "api"
    ],
    "credential_provider": "lemmy",
    "credential_kind": "service_account",
    "entry_url": "https://lemmy.world/create_post",
    "dynamic_host": true,
    "hosts": [
      "lemmy.world"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Instance composer URL",
            "实例编辑页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "community",
          "label": [
            "Community",
            "社区"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 200,
          "transfer": "text",
          "selectors": [
            "textarea#post-title",
            "input#post-title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 10000,
          "transfer": "text",
          "selectors": [
            "textarea[id^=\"markdown-textarea-\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "link",
          "label": [
            "Link",
            "链接"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#post-url"
          ]
        },
        {
          "key": "nsfw",
          "label": [
            "Adult content",
            "成人内容"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "否"
            ],
            "yes": [
              "Yes",
              "是"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": false,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "wrapcast",
    "name": "Farcaster",
    "methods": [
      "browser"
    ],
    "entry_url": "https://farcaster.xyz/",
    "dynamic_host": false,
    "hosts": [
      "farcaster.xyz"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Cast",
            "动态"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 800,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        },
        {
          "key": "channel",
          "label": [
            "Channel",
            "频道"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "no_video": true
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "farcaster.xyz",
      "warpcast.com"
    ]
  },
  {
    "id": "telegram",
    "name": "Telegram",
    "methods": [
      "browser"
    ],
    "entry_url": "https://web.telegram.org/a/",
    "dynamic_host": false,
    "hosts": [
      "web.telegram.org"
    ],
    "preview": {
      "layout": "chat",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Web chat URL",
            "网页版聊天网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Message",
            "消息"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 4096,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][role=\"textbox\"]"
          ],
          "format": "plain"
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_hosts": [
      "t.me",
      "telegram.me"
    ]
  },
  {
    "id": "nostr",
    "name": "Nostr",
    "methods": [
      "browser"
    ],
    "entry_url": "https://primal.net/",
    "dynamic_host": true,
    "hosts": [
      "primal.net"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Web client URL",
            "网页客户端网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Note",
            "笔记"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 100000,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"What’s on your mind?\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "vk",
    "name": "VK",
    "methods": [
      "browser"
    ],
    "entry_url": "https://vk.com/feed",
    "dynamic_host": false,
    "hosts": [
      "vk.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Community or profile URL",
            "社区或个人页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 2048,
          "transfer": "text",
          "selectors": [
            "#post_field"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "medium",
    "name": "Medium",
    "methods": [
      "browser"
    ],
    "entry_url": "https://medium.com/new-story",
    "dynamic_host": false,
    "hosts": [
      "medium.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "h3[data-testid=\"editorTitleParagraph\"]"
          ],
          "empty_values": [
            "Title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Story",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div.section-inner .graf--p"
          ],
          "empty_values": [
            "Tell your story…"
          ],
          "format": "rich_text"
        },
        {
          "key": "tags",
          "label": [
            "Topics",
            "主题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "canonical",
          "label": [
            "Canonical URL",
            "原文地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_custom_domain": true
  },
  {
    "id": "devto",
    "name": "DEV Community",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "devto",
    "credential_kind": "service_account",
    "entry_url": "https://dev.to/new",
    "dynamic_host": false,
    "hosts": [
      "dev.to"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 128,
          "transfer": "text",
          "selectors": [
            "textarea#article-form-title"
          ]
        },
        {
          "key": "body",
          "label": [
            "Markdown",
            "Markdown 正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea#article_body_markdown"
          ],
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#tag-input"
          ]
        },
        {
          "key": "canonical",
          "label": [
            "Canonical URL",
            "原文地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input#canonicalUrl"
          ]
        },
        {
          "key": "series",
          "label": [
            "Series",
            "系列"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "cover",
          "label": [
            "Cover image",
            "封面图"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "ai_disclosure",
          "label": [
            "AI disclosure",
            "AI 使用声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no_ai",
            "some_ai",
            "fully_autonomous"
          ],
          "option_labels": {
            "no_ai": [
              "No AI",
              "未使用 AI"
            ],
            "some_ai": [
              "Some AI assistance",
              "部分由 AI 协助"
            ],
            "fully_autonomous": [
              "Fully AI-generated",
              "完全由 AI 生成"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "unattended": {
      "account": "#user-profile-link-placeholder #first-nav-link",
      "submit": "#editor-actions button.c-btn--primary",
      "lands_on_post": true
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "hashnode",
    "name": "Hashnode",
    "methods": [
      "api",
      "browser"
    ],
    "credential_provider": "hashnode",
    "credential_kind": "service_account",
    "entry_url": "https://hashnode.com/draft",
    "dynamic_host": false,
    "hosts": [
      "hashnode.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"Article title…\"]"
          ],
          "min_length": 6
        },
        {
          "key": "subtitle",
          "label": [
            "Subtitle",
            "副标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 10000,
          "transfer": "guided",
          "selectors": [],
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "canonical",
          "label": [
            "Original article URL",
            "原文地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "publication",
          "label": [
            "Publication",
            "出版物"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "publication_custom_domain": true
  },
  {
    "id": "wordpress",
    "name": "WordPress",
    "methods": [
      "api"
    ],
    "credential_provider": "wordpress-site",
    "credential_kind": "service_account",
    "entry_url": "https://wordpress.org/",
    "dynamic_host": true,
    "hosts": [
      "wordpress.org"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "min_length": 2
        },
        {
          "key": "body",
          "label": [
            "Article",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 100000,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        },
        {
          "key": "excerpt",
          "label": [
            "Excerpt",
            "摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "slug",
          "label": [
            "Slug",
            "网址别名"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "categories",
          "label": [
            "Category IDs",
            "分类 ID"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "tags",
          "label": [
            "Tag IDs",
            "标签 ID"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "status",
          "label": [
            "Publish status",
            "发布状态"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "draft",
            "pending",
            "publish",
            "private"
          ],
          "option_labels": {
            "draft": [
              "Draft",
              "草稿"
            ],
            "pending": [
              "Pending review",
              "待审核"
            ],
            "publish": [
              "Publish publicly",
              "公开发布"
            ],
            "private": [
              "Private",
              "私密"
            ]
          }
        },
        {
          "key": "featured_media",
          "label": [
            "Featured media ID",
            "封面媒体 ID"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "listmonk",
    "name": "Listmonk",
    "methods": [
      "browser"
    ],
    "entry_url": "https://listmonk.app/",
    "dynamic_host": true,
    "hosts": [
      "listmonk.app"
    ],
    "preview": {
      "layout": "newsletter",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Campaign editor URL",
            "邮件编辑页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Campaign name",
            "邮件任务名称"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"name\"]"
          ]
        },
        {
          "key": "subject",
          "label": [
            "Subject",
            "邮件主题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"subject\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Email body",
            "邮件正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "rich_text"
        },
        {
          "key": "preview",
          "label": [
            "Preview text",
            "预览文字"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "list",
          "label": [
            "Recipient lists",
            "收件人列表"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "template",
          "label": [
            "Template",
            "模板"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "sender",
          "label": [
            "From address",
            "发件地址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "moltbook",
    "name": "Moltbook",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.moltbook.com/",
    "dynamic_host": false,
    "hosts": [
      "moltbook.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Content",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 300,
          "transfer": "text",
          "selectors": [
            "textarea[name=\"content\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "community",
          "label": [
            "Submolt",
            "社区"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "whop",
    "name": "Whop",
    "methods": [
      "browser"
    ],
    "entry_url": "https://whop.com/",
    "dynamic_host": false,
    "hosts": [
      "whop.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Community URL",
            "社区网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Content",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 50000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-lexical-editor=\"true\"]"
          ],
          "format": "markdown"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "skool",
    "name": "Skool",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.skool.com/",
    "dynamic_host": false,
    "hosts": [
      "skool.com"
    ],
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Group URL",
            "小组网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[placeholder=\"Title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 5000,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-placeholder=\"Write something...\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分类"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "mewe",
    "name": "MeWe",
    "methods": [
      "browser"
    ],
    "entry_url": "https://mewe.com/myworld",
    "dynamic_host": false,
    "hosts": [
      "mewe.com"
    ],
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Group or profile URL",
            "群组或个人页网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 63206,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-placeholder=\"Tell your contacts what’s happening\"]"
          ],
          "format": "plain"
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41"
  },
  {
    "id": "tumblr",
    "name": "Tumblr",
    "methods": [
      "browser"
    ],
    "entry_url": "https://www.tumblr.com/new/text",
    "dynamic_host": false,
    "hosts": [
      "tumblr.com"
    ],
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "[data-type=\"core/heading\"][contenteditable=\"true\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Post",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 32768,
          "transfer": "text",
          "selectors": [
            "[data-type=\"core/paragraph\"][contenteditable=\"true\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"#add tags\"]"
          ]
        },
        {
          "key": "blog",
          "label": [
            "Blog",
            "博客"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "slug",
          "label": [
            "Custom URL",
            "自定义网址"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*,video/*",
        "required": false,
        "multiple": true,
        "transfer": "guided",
        "max_count": 30
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user"
    },
    "upstream_ref": "36d5fc7b3ac3f17178b1589cf7a7337523017a41",
    "formats": [
      {
        "id": "text",
        "label": [
          "Text",
          "文章"
        ]
      },
      {
        "id": "link",
        "label": [
          "Link",
          "链接"
        ],
        "entry_url": "https://www.tumblr.com/new/link",
        "preview": {
          "layout": "social",
          "fields": [
            {
              "key": "link",
              "label": [
                "Link",
                "链接"
              ],
              "kind": "url",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "input[placeholder=\"Type or paste link\"]"
              ]
            },
            {
              "key": "tags",
              "label": [
                "Tags",
                "标签"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"#add tags\"]"
              ]
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow posts a link. Paste the address and Tumblr fetches the title and summary itself; there is no body until it has. Unattended publishing is not available.",
            "当前为链接贴:填入地址后由 Tumblr 自己抓标题和摘要，抓到之前没有正文框。暂不支持无人值守发布。"
          ]
        }
      },
      {
        "id": "photo",
        "label": [
          "Photo",
          "图片"
        ],
        "entry_url": "https://www.tumblr.com/new/photo",
        "preview": {
          "layout": "gallery",
          "fields": [
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "[data-type=\"core/paragraph\"][contenteditable=\"true\"]"
              ]
            },
            {
              "key": "tags",
              "label": [
                "Tags",
                "标签"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"#add tags\"]"
              ]
            }
          ],
          "media": {
            "accept": "image/*",
            "required": true,
            "multiple": true,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow posts pictures with a caption and no title. Upload first; the caption is the paragraph block under it.",
            "当前为图片贴:先上传图片，说明文字是下面那个段落块，没有标题。"
          ]
        }
      },
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ],
        "entry_url": "https://www.tumblr.com/new/video",
        "preview": {
          "layout": "video",
          "fields": [
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "[data-type=\"core/paragraph\"][contenteditable=\"true\"]"
              ]
            },
            {
              "key": "tags",
              "label": [
                "Tags",
                "标签"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"#add tags\"]"
              ]
            }
          ],
          "media": {
            "accept": "video/mp4,video/quicktime",
            "required": true,
            "multiple": false,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow posts one video with a caption and no title. Tumblr takes MP4 and QuickTime only.",
            "当前为视频贴:一段视频加说明文字，没有标题。Tumblr 只接受 MP4 和 QuickTime。"
          ]
        }
      }
    ]
  },
  {
    "id": "wechat",
    "name": "微信公众号",
    "entry_url": "https://mp.weixin.qq.com/",
    "hosts": [
      "mp.weixin.qq.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 64,
          "transfer": "text",
          "selectors": [
            "#title",
            "textarea[placeholder=\"请在这里输入标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".mock-iframe-body .ProseMirror[contenteditable=\"true\"]",
            "#ueditor_0 body[contenteditable=\"true\"]",
            "body.view[contenteditable=\"true\"]"
          ],
          "format": "rich_text",
          "empty_values": [
            "从这里开始写正文"
          ]
        },
        {
          "key": "author",
          "label": [
            "Author",
            "作者"
          ],
          "kind": "text",
          "required": false,
          "max_length": 8,
          "transfer": "text",
          "selectors": [
            "#author"
          ]
        },
        {
          "key": "summary",
          "label": [
            "Summary",
            "摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 120,
          "transfer": "text",
          "selectors": [
            "#js_description",
            "#digest"
          ]
        },
        {
          "key": "canonical",
          "label": [
            "Original link",
            "原文链接"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"source_url\"]",
            "#js_content_source_url"
          ]
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "original",
          "label": [
            "Originality",
            "原创声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "original"
          ],
          "option_labels": {
            "none": [
              "Not declared",
              "未声明"
            ],
            "original": [
              "Declare as original",
              "声明原创"
            ]
          }
        },
        {
          "key": "source",
          "label": [
            "Creation source",
            "创作来源"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collection",
          "label": [
            "Collection",
            "合集"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "recommend",
          "label": [
            "Platform recommendation",
            "平台推荐"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "on",
            "off"
          ],
          "option_labels": {
            "on": [
              "On — may appear in 看一看",
              "开启 — 可能被推荐至看一看"
            ],
            "off": [
              "Off — pushed to followers only",
              "不开启 — 仅推送给关注者"
            ]
          }
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Sign in, then create a new article in the draft box. Fill the article with the assistant; select a cover, review originality and confirm publication in WeChat. The original link sits in the article settings popover and is not on the page until that is open, so open it first if you want that field filled. Unattended publishing is not available.",
        "登录后在草稿箱新建图文，再用助手填入。原文链接在「文章设置」浮层里，浮层没打开时这个输入框不在页面上，需要填它就先打开。封面必选，原创声明及群发确认需在公众号后台完成；暂不支持无人值守发布。"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "zhihu",
    "name": "知乎",
    "entry_url": "https://zhuanlan.zhihu.com/write",
    "hosts": [
      "zhuanlan.zhihu.com"
    ],
    "publication_hosts": [
      "www.zhihu.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 100,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"请输入标题（最多 100 个字）\"]",
            ".WriteIndex-titleInput textarea"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".public-DraftEditor-content[contenteditable=\"true\"]",
            ".ProseMirror[contenteditable=\"true\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "文章封面"
          ],
          "kind": "image",
          "accept": "image/jpeg,image/png",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "question",
          "label": [
            "Submit to question",
            "投稿至问题（选填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Creator declaration",
            "创作声明"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "ai_assisted",
            "none",
            "spoiler",
            "medical",
            "fiction",
            "finance"
          ],
          "option_labels": {
            "ai_assisted": [
              "Includes AI-assisted writing",
              "包含 AI 辅助创作"
            ],
            "none": [
              "No declaration",
              "无声明"
            ],
            "spoiler": [
              "Contains spoilers",
              "包含剧透"
            ],
            "medical": [
              "Contains medical advice",
              "包含医疗建议"
            ],
            "fiction": [
              "Fiction",
              "虚构创作"
            ],
            "finance": [
              "Contains financial content",
              "包含理财内容"
            ]
          }
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "文章话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "source",
          "label": [
            "Content source",
            "内容来源（新闻类必填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": null
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Sign in and open the article editor. Review the filled title and body, then in Publish settings add the cover, question, creator declaration, topics and any content source, and confirm publication in Zhihu. Unattended publishing is not available.",
        "登录后打开写文章页面，核对填入的标题和正文；在“发布设置”中添加封面、投稿至问题、创作声明、文章话题和内容来源后，在知乎确认发布。暂不支持无人值守发布。"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "xiaohongshu",
    "name": "小红书",
    "entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=image",
    "hosts": [
      "creator.xiaohongshu.com"
    ],
    "publication_hosts": [
      "www.xiaohongshu.com",
      "xiaohongshu.com",
      "xhslink.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 20,
          "transfer": "text",
          "selectors": [
            "input[placeholder*=\"填写标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": 1000,
          "transfer": "text",
          "selectors": [
            ".tiptap[contenteditable=\"true\"]",
            ".ql-editor[contenteditable=\"true\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点（选填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Content declaration",
            "原创声明"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collection",
          "label": [
            "Collection",
            "加入合集"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": true,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "This flow creates an image note. Upload images first; once the editor appears, continue filling with the assistant. Review topics, cover and visibility before publishing. Unattended publishing is not available.",
        "当前支持图文笔记。先上传图片，编辑器出现后在助手中继续填入；话题、封面及可见范围在平台核对后发布。暂不支持无人值守发布。"
      ]
    },
    "formats": [
      {
        "id": "image",
        "label": [
          "Image note",
          "图文"
        ]
      },
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ],
        "entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=video",
        "preview": {
          "layout": "video",
          "media": {
            "accept": "video/*",
            "required": true,
            "multiple": false,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow creates a video note. Upload one video first; once it has processed, continue filling the title and body with the assistant. Choose the cover and review topics and visibility before publishing. Unattended publishing is not available.",
            "当前为视频笔记。先上传一个视频，处理完成后在助手中继续填入标题和正文；封面、话题及可见范围在平台核对后发布。暂不支持无人值守发布。"
          ]
        }
      },
      {
        "id": "article",
        "label": [
          "Long article",
          "长文"
        ],
        "entry_url": "https://creator.xiaohongshu.com/publish/publish?from=homepage&target=article",
        "preview": {
          "layout": "article",
          "fields": [
            {
              "key": "title",
              "label": [
                "Title",
                "标题"
              ],
              "kind": "text",
              "required": true,
              "max_length": 64,
              "transfer": "text",
              "selectors": [
                "textarea[placeholder=\"输入标题\"]"
              ]
            },
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                ".tiptap.ProseMirror"
              ],
              "format": "rich_text",
              "flattens_links": true
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow opens the long-article editor, which is reached from the long-form page rather than by address: open 写长文 and press 新的创作. Its editor keeps headings and drops links and bold, so the citation has to be a bare address in the text. Unattended publishing is not available.",
            "当前为长文编辑器。它不是一个可以直接打开的地址：在「写长文」页点「新的创作」才进得去。编辑器保留小标题，但会丢掉链接和加粗，所以回链要写成正文里的纯地址。暂不支持无人值守发布。"
          ]
        }
      }
    ],
    "upstream_ref": "ondit-native"
  },
  {
    "id": "douyin",
    "name": "抖音",
    "entry_url": "https://creator.douyin.com/creator-micro/content/upload",
    "hosts": [
      "creator.douyin.com"
    ],
    "publication_hosts": [
      "www.douyin.com",
      "v.douyin.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 30,
          "transfer": "text",
          "selectors": [
            "input[placeholder*=\"填写作品标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "作品描述"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div.zone-container[contenteditable=\"true\"]"
          ]
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "地点（选填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Upload one video first. Continue filling after processing; select the cover and review topics, visibility and any content declarations before publishing. Unattended publishing is not available.",
        "先上传一个视频，处理完成后继续填入标题和描述；在抖音核对封面、话题、可见范围及内容声明，再确认发布。暂不支持无人值守发布。"
      ]
    },
    "upstream_ref": "ondit-native",
    "formats": [
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ]
      },
      {
        "id": "article",
        "label": [
          "Article",
          "文章"
        ],
        "entry_url": "https://creator.douyin.com/creator-micro/content/post/article?media_type=article&type=new",
        "preview": {
          "layout": "article",
          "fields": [
            {
              "key": "title",
              "label": [
                "Title",
                "文章标题"
              ],
              "kind": "text",
              "required": true,
              "max_length": 30,
              "transfer": "text",
              "selectors": [
                "input[placeholder^=\"请输入文章标题\"]"
              ]
            },
            {
              "key": "summary",
              "label": [
                "Summary",
                "文章摘要"
              ],
              "kind": "text",
              "required": false,
              "max_length": 30,
              "transfer": "text",
              "selectors": [
                "input[placeholder^=\"添加内容摘要\"]"
              ]
            },
            {
              "key": "body",
              "label": [
                "Body",
                "文章正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": 20000,
              "transfer": "text",
              "selectors": [
                "[contenteditable=\"true\"][role=\"textbox\"]"
              ],
              "format": "rich_text",
              "flattens_links": true
            },
            {
              "key": "cover",
              "label": [
                "Cover",
                "封面"
              ],
              "kind": "image",
              "required": true,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "accept": "image/*"
            },
            {
              "key": "header_image",
              "label": [
                "Header image",
                "文章头图"
              ],
              "kind": "image",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "accept": "image/*"
            },
            {
              "key": "topics",
              "label": [
                "Topics",
                "话题"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "visibility",
              "label": [
                "Who can see it",
                "谁可以看"
              ],
              "kind": "select",
              "required": true,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "public",
                "friends",
                "private"
              ],
              "option_labels": {
                "public": [
                  "Public",
                  "公开"
                ],
                "friends": [
                  "Friends",
                  "好友可见"
                ],
                "private": [
                  "Only me",
                  "仅自己可见"
                ]
              }
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow opens Douyin's article editor, which takes no upload: the title, summary and body fill straight away. A cover is required before it will publish, and the header image, topics and who may see it are set on the platform. Unattended publishing is not available. The editor drops a link and writes \"该文本类型暂不支持，请替换素材\" into the body where it was, so the citation has to be a bare address in the text rather than a link, and that line is removed before publishing.",
            "当前为抖音文章，无需上传：标题、摘要与正文可直接填入。发布前必须在平台设置封面；头图、话题与可见范围也在平台核对。暂不支持无人值守发布。该编辑器会丢掉链接，并在原处写入「该文本类型暂不支持，请替换素材」，所以回链要写成正文里的纯地址，并在发布前删掉这句提示。"
          ]
        }
      }
    ]
  },
  {
    "id": "bilibili",
    "name": "哔哩哔哩",
    "entry_url": "https://member.bilibili.com/platform/upload/video/frame",
    "hosts": [
      "member.bilibili.com"
    ],
    "publication_hosts": [
      "www.bilibili.com",
      "b23.tv"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": 80,
          "transfer": "text",
          "selectors": [
            ".video-title input",
            "input[placeholder=\"请输入稿件标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Description",
            "视频简介"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 2000,
          "transfer": "text",
          "selectors": [
            ".desc-text-wrp .ql-editor[contenteditable=\"true\"]",
            ".ql-editor[contenteditable=\"true\"]"
          ]
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分区（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "copyright",
          "label": [
            "Copyright",
            "稿件类型"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "original",
            "repost"
          ],
          "option_labels": {
            "original": [
              "Original",
              "自制"
            ],
            "repost": [
              "Repost",
              "转载"
            ]
          }
        },
        {
          "key": "source",
          "label": [
            "Source URL for reposts",
            "转载来源（转载时必填）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "required_when": {
            "field": "copyright",
            "value": "repost"
          }
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Upload one video, then continue filling. Category, tags and cover must be set in Bilibili; confirm original/repost and provide the source for reposts. Unattended publishing is not available.",
        "先上传一个视频，再继续填入。分区、标签、封面需在 B 站填写，核对自制／转载类型；转载必须补充来源。暂不支持无人值守发布。"
      ]
    },
    "upstream_ref": "ondit-native",
    "formats": [
      {
        "id": "video",
        "label": [
          "Video",
          "视频"
        ]
      },
      {
        "id": "article",
        "label": [
          "Column",
          "专栏"
        ],
        "entry_url": "https://member.bilibili.com/york/read-editor",
        "preview": {
          "layout": "article",
          "fields": [
            {
              "key": "title",
              "label": [
                "Title",
                "标题"
              ],
              "kind": "text",
              "required": true,
              "max_length": null,
              "transfer": "text",
              "selectors": [
                "textarea.title-input__inner"
              ]
            },
            {
              "key": "body",
              "label": [
                "Body",
                "正文"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": 100000,
              "transfer": "text",
              "selectors": [
                ".tiptap.ProseMirror.eva3-editor"
              ],
              "format": "rich_text",
              "flattens_links": true
            },
            {
              "key": "cover",
              "label": [
                "Cover",
                "自定义封面"
              ],
              "kind": "image",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "accept": "image/*"
            },
            {
              "key": "visibility",
              "label": [
                "Who can see it",
                "可见范围"
              ],
              "kind": "select",
              "required": true,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "all",
                "private"
              ],
              "option_labels": {
                "all": [
                  "Everyone",
                  "所有人可见"
                ],
                "private": [
                  "Only me",
                  "仅自己可见"
                ]
              }
            },
            {
              "key": "original",
              "label": [
                "Declare as original",
                "创作声明"
              ],
              "kind": "select",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "no",
                "yes"
              ],
              "option_labels": {
                "no": [
                  "No",
                  "不声明"
                ],
                "yes": [
                  "Original, no reposting",
                  "原创，禁止转载"
                ]
              }
            },
            {
              "key": "ai_assisted",
              "label": [
                "AI-assisted",
                "AI辅助创作声明"
              ],
              "kind": "select",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "no",
                "yes"
              ],
              "option_labels": {
                "no": [
                  "No",
                  "否"
                ],
                "yes": [
                  "Yes",
                  "是"
                ]
              }
            },
            {
              "key": "topics",
              "label": [
                "Topics",
                "话题"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "collection",
              "label": [
                "Collection",
                "文集"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            }
          ],
          "media": null
        },
        "browser": {
          "instructions": [
            "This flow opens Bilibili's column editor, which takes no upload: the title and body fill straight away. The cover, who may see it, the originality and AI declarations, topics and the collection are set on the platform. Unattended publishing is not available. The editor keeps the words and drops every link, so the citation has to be a bare address in the text.",
            "当前为 B 站专栏，无需上传：标题与正文可直接填入。封面、可见范围、原创与 AI 辅助声明、话题与文集在平台核对后发布。暂不支持无人值守发布。该编辑器保留文字但丢掉所有链接，所以回链要写成正文里的纯地址。"
          ]
        }
      }
    ]
  },
  {
    "id": "weibo",
    "name": "微博",
    "entry_url": "https://weibo.com/",
    "hosts": [
      "weibo.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "social",
      "fields": [
        {
          "key": "body",
          "label": [
            "Post",
            "微博正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"有什么新鲜事想分享给大家？\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "audience",
          "label": [
            "Audience",
            "可见范围"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Content declaration",
            "内容声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "ai_generated",
            "fiction"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "ai_generated": [
              "Contains AI-generated content",
              "含AI生成内容"
            ],
            "fiction": [
              "Fiction",
              "虚构内容"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Sign in and open the post composer. Add images and choose topics and audience on Weibo. Review and publish on the platform; unattended publishing is unavailable.",
        "登录微博后打开发微博输入框；图片、话题及可见范围在微博设置。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "toutiao",
    "name": "今日头条",
    "entry_url": "https://mp.toutiao.com/profile_v4/graphic/publish",
    "hosts": [
      "mp.toutiao.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder^=\"请输入文章标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".ProseMirror[contenteditable=\"true\"]",
            ".ql-editor[contenteditable=\"true\"]"
          ],
          "format": "rich_text",
          "empty_values": [
            "请输入正文"
          ],
          "flattens_links": true
        },
        {
          "key": "declaration",
          "label": [
            "Content declaration",
            "作品声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "web_sourced",
            "site_quoted",
            "opinion",
            "ai_quoted",
            "fiction",
            "investment",
            "health"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "web_sourced": [
              "Sourced from the web",
              "取材网络"
            ],
            "site_quoted": [
              "Quoted from this site",
              "引用站内"
            ],
            "opinion": [
              "Personal opinion",
              "个人观点，仅供参考"
            ],
            "ai_quoted": [
              "Quotes AI output",
              "引用AI"
            ],
            "fiction": [
              "Fiction",
              "虚构演绎，故事经历"
            ],
            "investment": [
              "Investment view",
              "投资观点，仅供参考"
            ],
            "health": [
              "Health or medical",
              "健康医疗分享，仅供参考"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "cover_mode",
          "label": [
            "Cover layout",
            "展示封面"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "one",
            "three",
            "none"
          ],
          "option_labels": {
            "one": [
              "One image",
              "单图"
            ],
            "three": [
              "Three images",
              "三图"
            ],
            "none": [
              "No cover",
              "无封面"
            ]
          }
        },
        {
          "key": "first_publish",
          "label": [
            "Declare first publication",
            "声明首发"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "no",
            "yes"
          ],
          "option_labels": {
            "no": [
              "No",
              "不声明"
            ],
            "yes": [
              "Toutiao first",
              "头条首发"
            ]
          }
        },
        {
          "key": "location",
          "label": [
            "Location",
            "添加位置"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "collection",
          "label": [
            "Collection",
            "合集"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "This flow creates an article. Sign in to Toutiao, review the body, cover and originality declaration. The editor keeps the words of a pasted body and drops its links, so any link in the article — the citation back to the ondit page included — arrives as plain text and has to be added by hand if it matters. Review and publish on the platform; unattended publishing is unavailable.",
        "此入口发布图文文章。登录头条号后核对正文，选择封面和原创声明。编辑器会保留粘贴正文的文字、丢掉其中的链接，所以文章里的链接（包括回指 ondit 页面的引用）到这里都是纯文字，需要的话请手动补回。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "toutiao.com"
    ]
  },
  {
    "id": "baijiahao",
    "name": "百家号",
    "entry_url": "https://baijiahao.baidu.com/builder/rc/edit?type=news",
    "hosts": [
      "baijiahao.baidu.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".input-box [contenteditable=\"true\"][data-lexical-editor=\"true\"]",
            "[contenteditable=\"true\"][data-lexical-editor=\"true\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "body.view[contenteditable=\"true\"]",
            ".ProseMirror[contenteditable=\"true\"]"
          ],
          "format": "rich_text",
          "flattens_links": true
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分类"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "declaration",
          "label": [
            "Creator declaration",
            "创作声明"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "none",
            "ai_generated"
          ],
          "option_labels": {
            "none": [
              "None",
              "无"
            ],
            "ai_generated": [
              "Contains AI-generated content",
              "采用AI生成内容"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "cover_mode",
          "label": [
            "Cover layout",
            "设置封面"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "one",
            "three"
          ],
          "option_labels": {
            "one": [
              "One image",
              "单图"
            ],
            "three": [
              "Three images",
              "三图"
            ]
          }
        },
        {
          "key": "source",
          "label": [
            "Source note",
            "来源说明"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Open the article editor and review images, cover, category and source declarations. This entry resumes the last draft rather than opening a blank one, so start a new article before filling unless you mean to continue that draft. The editor keeps the words of a pasted body and drops its links, so any link in the article — the citation back to the ondit page included — arrives as plain text and has to be added by hand if it matters. Review and publish on the platform; unattended publishing is unavailable.",
        "此入口发布图文文章。选择图文编辑器，检查图片、封面、分类和来源声明。这个地址打开的是上一篇未完成的草稿而不是空白编辑器，除非就是要接着写那篇，否则请先新建一篇再填入。编辑器会保留粘贴正文的文字、丢掉其中的链接，所以文章里的链接（包括回指 ondit 页面的引用）到这里都是纯文字，需要的话请手动补回。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "baijiahao.baidu.com"
    ],
    "formats": [
      {
        "id": "article",
        "label": [
          "Article",
          "图文"
        ]
      },
      {
        "id": "moment",
        "label": [
          "Moment",
          "动态"
        ],
        "entry_url": "https://baijiahao.baidu.com/builder/rc/edit?type=events",
        "preview": {
          "layout": "social",
          "fields": [
            {
              "key": "body",
              "label": [
                "Body",
                "作品描述"
              ],
              "kind": "textarea",
              "required": true,
              "max_length": 2000,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "topics",
              "label": [
                "Topics",
                "话题"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "location",
              "label": [
                "Location",
                "添加地点"
              ],
              "kind": "text",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": []
            },
            {
              "key": "declaration",
              "label": [
                "Creator declaration",
                "创作声明"
              ],
              "kind": "select",
              "required": false,
              "max_length": null,
              "transfer": "guided",
              "selectors": [],
              "options": [
                "none",
                "ai_generated"
              ],
              "option_labels": {
                "none": [
                  "None",
                  "无"
                ],
                "ai_generated": [
                  "Contains AI-generated content",
                  "采用AI生成内容"
                ]
              }
            }
          ],
          "media": {
            "accept": "image/*",
            "required": false,
            "multiple": true,
            "transfer": "guided"
          }
        },
        "browser": {
          "instructions": [
            "This flow posts a moment: a short body of up to 2,000 characters with optional pictures. There is no title. Topics, location and the creator declaration are set on the platform. Unattended publishing is not available.",
            "当前为动态：一段不超过 2000 字的正文，可选配图，没有标题。话题、地点与创作声明在平台核对后发布。暂不支持无人值守发布。"
          ]
        }
      }
    ]
  },
  {
    "id": "kuaishou",
    "name": "快手",
    "entry_url": "https://cp.kuaishou.com/article/publish/video",
    "hosts": [
      "cp.kuaishou.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "video",
      "fields": [
        {
          "key": "body",
          "label": [
            "Video description",
            "视频描述"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "div[contenteditable=\"true\"]"
          ],
          "format": "plain"
        },
        {
          "key": "topics",
          "label": [
            "Topics",
            "话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "audience",
          "label": [
            "Who can see it",
            "查看权限"
          ],
          "kind": "select",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "all",
            "friends",
            "private"
          ],
          "option_labels": {
            "all": [
              "Everyone",
              "所有人可见"
            ],
            "friends": [
              "Friends",
              "好友可见"
            ],
            "private": [
              "Only me",
              "仅自己可见"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "declaration",
          "label": [
            "Author's note",
            "作者声明"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "location",
          "label": [
            "Location",
            "添加地点"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "video/*",
        "required": true,
        "multiple": false,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Upload the video yourself and wait for processing before continuing: Kuaishou ignores a file the assistant attaches, so this one step is always manual. The description is filled once the editor appears. Set the cover, topics and audience on Kuaishou. Review and publish on the platform; unattended publishing is unavailable.",
        "请自己上传视频并等待处理完成——快手会忽略助手附加的文件，所以这一步只能手动。编辑器出现后助手会填入描述。封面、话题及可见范围在快手设置。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "kuaishou.com",
      "v.kuaishou.com"
    ]
  },
  {
    "id": "csdn",
    "name": "CSDN",
    "entry_url": "https://editor.csdn.net/md/",
    "hosts": [
      "editor.csdn.net"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input.article-bar__title",
            "input[placeholder^=\"请输入文章标题\"]"
          ],
          "empty_values": [
            "【无标题】"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Article tags",
            "文章标签"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "category",
          "label": [
            "Column",
            "分类专栏"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "source",
          "label": [
            "Article type",
            "文章类型"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "original",
            "reprint",
            "translation"
          ],
          "option_labels": {
            "original": [
              "Original",
              "原创"
            ],
            "reprint": [
              "Reprint",
              "转载"
            ],
            "translation": [
              "Translation",
              "翻译"
            ]
          }
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "summary",
          "label": [
            "Summary",
            "文章摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 256,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "visibility",
          "label": [
            "Who can see it",
            "可见范围"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "all",
            "private",
            "followers",
            "vip"
          ],
          "option_labels": {
            "all": [
              "Everyone",
              "全部可见"
            ],
            "private": [
              "Only me",
              "仅我可见"
            ],
            "followers": [
              "Followers",
              "粉丝可见"
            ],
            "vip": [
              "VIP",
              "VIP可见"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Use the Markdown editor. The header shows the title as a label until it is clicked, so click it first — the box does not exist until then and the assistant cannot fill it. Copy the body from the assistant into the Markdown editor. Choose tags and originality/source in publication settings. Review and publish on the platform; unattended publishing is unavailable.",
        "使用 Markdown 编辑器。标题栏默认显示为【无标题】，点一下才会变成输入框——在那之前这个框不存在，助手填不进去，所以请先点开它。正文请用助手复制后粘贴到 Markdown 编辑区，避免破坏编辑器状态。发布设置中选择标签和原创／转载来源。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "blog.csdn.net"
    ]
  },
  {
    "id": "juejin",
    "name": "稀土掘金",
    "entry_url": "https://juejin.cn/editor/drafts/new",
    "hosts": [
      "juejin.cn"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[placeholder=\"输入文章标题...\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "markdown"
        },
        {
          "key": "category",
          "label": [
            "Category",
            "分类"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "backend",
            "frontend",
            "android",
            "ios",
            "ai",
            "tooling",
            "career",
            "reading"
          ],
          "option_labels": {
            "backend": [
              "Backend",
              "后端"
            ],
            "frontend": [
              "Frontend",
              "前端"
            ],
            "android": [
              "Android",
              "Android"
            ],
            "ios": [
              "iOS",
              "iOS"
            ],
            "ai": [
              "AI",
              "人工智能"
            ],
            "tooling": [
              "Developer tools",
              "开发工具"
            ],
            "career": [
              "Career",
              "代码人生"
            ],
            "reading": [
              "Reading",
              "阅读"
            ]
          }
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签（在平台选择）"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "summary",
          "label": [
            "Summary",
            "编辑摘要"
          ],
          "kind": "textarea",
          "required": false,
          "max_length": 100,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "cover",
          "label": [
            "Cover",
            "封面"
          ],
          "kind": "image",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "accept": "image/*"
        },
        {
          "key": "column",
          "label": [
            "Columns",
            "收录至专栏"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "topic",
          "label": [
            "Topic",
            "创作话题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Use the Markdown editor and paste the body from the assistant. Choose category and tags, and review the summary and cover before publishing. Review and publish on the platform; unattended publishing is unavailable.",
        "使用 Markdown 编辑器，正文通过助手复制粘贴；发布前在掘金选择分类和标签，并核对摘要与封面。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "segmentfault",
    "name": "SegmentFault",
    "entry_url": "https://segmentfault.com/write",
    "hosts": [
      "segmentfault.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[name=\"title\"]",
            "input[placeholder=\"标题\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[name=\"text\"]"
          ],
          "format": "markdown"
        },
        {
          "key": "tags",
          "label": [
            "Tags",
            "标签（在平台选择）"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "blog",
          "label": [
            "Blog",
            "所属专栏"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Open Write an article. If the body editor cannot be identified, copy Markdown from the assistant. Select tags and the blog on the platform. Review and publish on the platform; unattended publishing is unavailable.",
        "打开写文章页面。若正文编辑器无法识别，请使用助手复制 Markdown；标签及所属专栏在平台选择。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "jianshu",
    "name": "简书",
    "entry_url": "https://www.jianshu.com/writer",
    "hosts": [
      "www.jianshu.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "article",
      "fields": [
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "input[type=\"text\"]:not([placeholder])"
          ],
          "empty_values": [
            "/^\\d{4}-\\d{2}-\\d{2}$/"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "format": "markdown"
        },
        {
          "key": "notebook",
          "label": [
            "Notebook",
            "文集（在平台选择）"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Choose a notebook and create a new article. This flow supplies Markdown: switch to the Markdown editor before pasting. Keep existing articles intact. Review and publish on the platform; unattended publishing is unavailable.",
        "先选择文集并新建文章。此流程使用 Markdown 正文，请切换到 Markdown 编辑器后粘贴；不要覆盖已有文章。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native",
    "publication_hosts": [
      "jianshu.com"
    ]
  },
  {
    "id": "quora",
    "name": "Quora",
    "entry_url": "https://www.quora.com/",
    "hosts": [
      "www.quora.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "discussion",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Question URL",
            "要回答的问题网址"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "body",
          "label": [
            "Answer",
            "回答正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "[contenteditable=\"true\"][data-kind=\"doc\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "credential",
          "label": [
            "Answer credential",
            "回答身份／资历"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Enter a question URL and click Answer on that question. Adapt the content into a relevant answer, then review images and answer credentials in Quora. Review and publish on the platform; unattended publishing is unavailable.",
        "填写具体问题网址，打开问题后点击 Answer。此流程用于回答问题，请先将内容改写为切题的回答；图片和身份信息在 Quora 核对。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native"
  },
  {
    "id": "substack",
    "name": "Substack",
    "entry_url": "https://substack.com/publish",
    "hosts": [
      "substack.com"
    ],
    "methods": [
      "browser"
    ],
    "dynamic_host": false,
    "preview": {
      "layout": "newsletter",
      "fields": [
        {
          "key": "destination",
          "label": [
            "Publication editor URL (*.substack.com/publish/…)",
            "刊物编辑页网址（*.substack.com/publish/…）"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": []
        },
        {
          "key": "title",
          "label": [
            "Title",
            "标题"
          ],
          "kind": "text",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"Title\"]",
            "input[placeholder=\"Title\"]"
          ]
        },
        {
          "key": "body",
          "label": [
            "Body",
            "正文"
          ],
          "kind": "textarea",
          "required": true,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            ".tiptap[contenteditable=\"true\"]",
            ".ProseMirror[contenteditable=\"true\"]"
          ],
          "format": "rich_text"
        },
        {
          "key": "subtitle",
          "label": [
            "Subtitle",
            "副标题"
          ],
          "kind": "text",
          "required": false,
          "max_length": null,
          "transfer": "text",
          "selectors": [
            "textarea[placeholder=\"Subtitle\"]"
          ]
        },
        {
          "key": "audience",
          "label": [
            "Audience",
            "免费／付费受众"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "everyone",
            "paid",
            "free"
          ],
          "option_labels": {
            "everyone": [
              "Everyone",
              "所有读者"
            ],
            "paid": [
              "Paid subscribers",
              "付费订阅者"
            ],
            "free": [
              "Free subscribers",
              "免费订阅者"
            ]
          }
        },
        {
          "key": "delivery",
          "label": [
            "Email and app delivery",
            "是否发送邮件和 App 通知"
          ],
          "kind": "select",
          "required": true,
          "max_length": null,
          "transfer": "guided",
          "selectors": [],
          "options": [
            "web_only",
            "email_and_app"
          ],
          "option_labels": {
            "web_only": [
              "Web only",
              "仅发布到网页"
            ],
            "email_and_app": [
              "Email and app inbox",
              "同时发送邮件和 App 通知"
            ]
          }
        }
      ],
      "media": {
        "accept": "image/*",
        "required": false,
        "multiple": true,
        "transfer": "guided"
      }
    },
    "browser": {
      "verification": "needs_live_verification",
      "fill": "assisted",
      "final_action": "user",
      "instructions": [
        "Enter the new-article editor URL for your publication on substack.com. Choose the audience and explicitly review whether to send email and app notifications. Review and publish on the platform; unattended publishing is unavailable.",
        "填写自己刊物的新文章编辑页网址，仅支持 substack.com 域名。核对受众，并在发布时明确选择是否发送邮件和 App 通知。 请在平台核对并点击发布，暂不支持定时自动提交。"
      ]
    },
    "upstream_ref": "ondit-native"
  }
]
